import { Controller } from 'stimulus';
import { triggerCustomEvent } from 'lib/helpers';
import Cookies from 'js-cookie';
import events from 'lib/events';

export default class PromoPopupController extends Controller {
  connect() {
    setTimeout(() => {
      this.element.classList.remove('is-hidden');

      triggerCustomEvent(events.promos.promo_popup.popped);
    }, 3000);
  }

  close = () => {
    this.element.classList.add('is-hidden');

    Cookies.set('dismissed_promo_popup', '1');

    triggerCustomEvent(events.promos.promo_popup.dismissed);
  }

  ctaClick = () => {
    triggerCustomEvent(events.promos.promo_popup.cta_click);
  }
}
